import { NavLink } from "react-router-dom";
import scrollToTop from "../components/scrolltotop";
const CoursesNav = () => {
  return (
    <>
      <div className="courses-nav-container">
        <NavLink
          onClick={scrollToTop}
          to="/subjects/maths"
          className="courses-nav-link"
          style={({ isActive }) => ({
            color: isActive ? "#7C2C99" : "#787878",
          })}
        >
          Math<span className="nav-shortener">ematic</span>s
        </NavLink>
        <hr />
        <NavLink
          onClick={scrollToTop}
          to="/subjects/english"
          className="courses-nav-link"
          style={({ isActive }) => ({
            color: isActive ? "#BF9000" : "#787878",
          })}
        >
          English
        </NavLink>
        <hr />
        <NavLink
          onClick={scrollToTop}
          to="/subjects/verbal-reasoning"
          className="courses-nav-link"
          style={({ isActive }) => ({
            color: isActive ? "#548235" : "#787878",
          })}
        >
          V<span className="nav-shortener">erbal </span>R
          <span className="nav-shortener">easoning</span>
        </NavLink>{" "}
        <hr />
        <NavLink
          onClick={scrollToTop}
          to="/subjects/non-verbal-reasoning"
          className="courses-nav-link"
          style={({ isActive }) => ({
            color: isActive ? "#FF8A3B" : "#787878",
          })}
        >
          N<span className="nav-shortener">on-</span>V
          <span className="nav-shortener">erbal </span>R
          <span className="nav-shortener">easoning</span>
        </NavLink>
      </div>
    </>
  );
};

export default CoursesNav;
